import { initializeApp } from 'firebase/app'

import { getMessaging } from 'firebase/messaging'
import { getFirestore } from 'firebase/firestore'
import { ENV } from '@/constants/env'

//Firebase Config values imported from .env file
const firebaseConfig = JSON.parse(ENV.VITE_FIREBASE_CONFIG)

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Messaging service
export const messaging = getMessaging(app)
export const fireStore = getFirestore(app, ENV.VITE_FIREBASE_DATABASE)
